export default __webpack_public_path__ + "static/jobs-economic-justice-accomplishment-1-ba895285948cb41ff3543c8b1145581c.webp";